import styled from "styled-components";

export const InfoUser = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;
  justify-content: flex-end;

  margin-right: 10px;
  border-radius: 8px;

  z-index: 6;

  cursor: pointer;
  overflow: hidden;

  .info-user {
    display: flex;
    flex-direction: column;

    align-items: flex-end;
    justify-content: center;

    margin-right: 20px;

    h3 {
      font-size: 18px;
    }

    span {
      font-size: 14px;
      color: #555;
    }
  }

  .icon-user {
    height: 40px;
    width: 40px;

    background: #333;
    border-radius: 50%;
    display: flex;

    align-items: center;
    justify-content: center;
  }

  .triangulo {
    margin: 5px 5px 0 5px;

    transition: 0.4s;
    transform: rotate(0deg);
  }

  .triangulo-active {
    margin: 5px 5px 0 5px;
    transform: rotate(180deg);

    transition: 0.4s;
  }

  &:active:hover {
    background: none;
  }

  @media (max-width: 901px) {
    .info-user {
      margin-right: 0px;

      h3 {
        display: none;
      }

      span {
        display: none;
      }
    }
  }
`;

interface OptionNavProps {
  isClient: boolean;
}

export const OptionNav = styled.ul<OptionNavProps>`
  box-shadow: 0px 3px 5px 1px rgba(0, 0, 0, 0.59);

  position: absolute;
  top: 47px;
  right: -95px;
  width: 250px;
  border-radius: 5px;

  background-color: #fff;
  transform: translateX(-45%);
  overflow: hidden;
  list-style: none;
  z-index: 11;

  li {
    display: flex;
    align-items: center;
    transition: all 0.3s;

    padding: 12px 15px;
    width: 100%;

    svg {
      margin-right: 10px;
    }
  }

  li:hover {
    background-color: #ccc;
  }

  a {
    text-decoration: none;
    color: #333;
  }

  animation: fadeoutperfil 0.3s;

  @keyframes fadeoutperfil {
    from {
      opacity: 0;
      height: 5px;
    }

    to {
      opacity: 1;
      height: ${(props) => (props.isClient ? 176 : 88)}px;
    }
  }
`;
